<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdwxlist-up',title:'订单管理'},{title:'订单上传凭证'}]" v-if="firstPageFlag!=1"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                	<div class="h-thirdColumn w-newColumn">
                		<el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
                		    <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                		</el-form-item>
                		<el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
                		    <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"
                		              style="width: 100%"></el-input>
                		</el-form-item>
						<el-form-item label="　区域编码/名称" prop="sdfCodeNameLike">
							<el-select
									v-model="formInline.qyname"
									placeholder="--请选择--"
									clearable
									filterable>
								<el-option
										v-for="item in areaData"
										:key="item.code"
										:label="item.name"
										:value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
                		<el-form-item label="订单状态" prop="status">
                		    <brselect clearable category="order_status" :v="formInline.status"
                		              v-model="formInline.status"></brselect>
                		</el-form-item>
                	</div>

                	<el-collapse-transition>
                		<div v-show="isScreen">
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="提单号" prop="billCode">
                				    <el-input v-model="formInline.billCode" placeholder="请输入"
                				              ></el-input>
                				</el-form-item>
                				<el-form-item label="　报关单状态" prop="customsCode">
                				    <el-select v-model="formInline.csstatus" :clearable="true"
                				               placeholder="请选择">
                				        <el-option label="已录入" value="1"></el-option>
                				        <el-option label="未录入" value="2"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="提单日期" prop="bdatebegin"  style="width: 50%;">
                				    <el-date-picker
                						v-model="formInline.bdatebegin"
                						clearable
                						type="date"
                						value-format="yyyy-MM-dd" >
                				    </el-date-picker>
                				    <span class="w-time-to">至</span>
                				    <el-date-picker
                						v-model="formInline.bdateend"
                						clearable
                						type="date"
                						value-format="yyyy-MM-dd" >
                				    </el-date-picker>
                				</el-form-item>

                			</div>
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="是否上传入货通知" prop="billCode">
                				    <el-select v-model="formInline.rhstatus" :clearable="true"
                				               placeholder="请选择">
                				        <el-option label="已上传" value="1"></el-option>
                				        <el-option label="未上传" value="2"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="报关单号" prop="customsCode">
                				    <el-input v-model="formInline.customsCode" placeholder="请输入"
                				              ></el-input>
                				</el-form-item>
                				<el-form-item label="　　订单创建时间" prop="cdatebegin" style="width: 50%;">
                				    <el-date-picker
                						v-model="formInline.cdatebegin"
                						clearable
                						type="date"
                						value-format="yyyy-MM-dd" >
                				    </el-date-picker>
                				    <span class="w-time-to">至</span>
                				    <el-date-picker
                						v-model="formInline.cdateend"
                						clearable
                						type="date"
                						value-format="yyyy-MM-dd" >
                				    </el-date-picker>
                				</el-form-item>

                			</div>
                			<div class="h-thirdColumn w-newColumn">
                				<el-form-item label="提单状态" prop="billCode">
                				    <el-select v-model="formInline.blstatus" :clearable="true"
                				               placeholder="请选择">
                				        <el-option label="已录入" value="1"></el-option>
                				        <el-option label="未录入" value="2"></el-option>
                				    </el-select>
                				</el-form-item>
                				<el-form-item label="　　系统发票号" prop="add4">
                				    <el-input v-model="formInline.add4" placeholder="请输入"
                				              style="width: 100%"></el-input>
                				</el-form-item>
                				<el-form-item label="　　发票是否创建" prop="billingStatus">
                					<el-select v-model="formInline.billingStatus" :clearable="true"
                							   placeholder="请选择">
                						<el-option label="是" value="Y"></el-option>
                						<el-option label="否" value="N"></el-option>
                					</el-select>
                				</el-form-item>
                			</div>
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="发货时间" prop="fhdatebegin" style="width: 50%;">
									<el-date-picker
											v-model="formInline.fhdatebegin"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											v-model="formInline.fhdateend"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
								<el-form-item label="系统发票日期" prop="invoicejsDatebegin" style="width: 50%;">
									<el-date-picker
											v-model="formInline.invoicejsDatebegin"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
											v-model="formInline.invoicejsDateend"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
							</div>
                		</div>
                	</el-collapse-transition>

                    <!-- <div class="h-formBtnOut h-columnCenter">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                                   @click="imgfalse3" v-if="firstPageFlag!=1">
                            新建订单
                        </el-button>
                        <el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
                                   @click="caiwushouhuo">
                            收货
                        </el-button>
                    </div> -->
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
						           @click="imgfalse3" v-if="firstPageFlag!=1">
						    新建订单
						</el-button>
						<el-button v-auth="'caiwushouhuo'" class="h-btn h-formBtn h-bggreen"
						           @click="caiwushouhuo">
						    收货
						</el-button>
					</div>
				</div>
            </div>
        </div>
		<div>
			<p style="color:red;margin-left: 20px;font-size: 14px;font-weight: bolder;">报关单、入货通知、发票、提单、格式要求   “订单号+文件名”  比如 SWW9004470结算发票，PDF格式文件。</p>
		</div>
		<div class="h-row">
			<div class="h-rowIn" style="width:100%;">
				<div style="background:#fff;width:100%;">
					<el-table
							ref="ddtable"
							:data="tableData"
							:span-method="objectSpanMethod"
							@selection-change="handleSelectionChange"
							:row-class-name="tableRowClassName"
							border
							:show-overflow-tooltip="true"
							style="width: 100%"
							max-height="450"
					>
						<el-table-column
								type="selection"
								fixed
								width="40">
						</el-table-column>
						<el-table-column
								type="index"
								fixed
								label="#"
								width="40">
						</el-table-column>
						<el-table-column
								prop="sapCode"
								label="订单号"
								fixed
								:show-overflow-tooltip="true"
								width="120">
						</el-table-column>
						<el-table-column
								prop="materialCode"
								label="产品编码"
								:show-overflow-tooltip="true"
								width="110">
						</el-table-column>
						<el-table-column
								prop="materialName"
								label="产品名称"
								:show-overflow-tooltip="true"
								width="180">
								<template scope="scope">
									<div style="text-align: left;">
										{{scope.row.materialName}}
									</div>
								</template>
						</el-table-column>
						<el-table-column
								prop="proNumber"
								label="数量"
								:show-overflow-tooltip="true"
								width="60">
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.proNumber}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="status"
								label="订单状态"
								:show-overflow-tooltip="true"
								width="110">
							<template scope="scope">
								{{scope.row.status|dictname('order_status')}}
							</template>
						</el-table-column>
						<el-table-column
								prop="orderCategory"
								label="订单类型"
								:show-overflow-tooltip="true"
								width="120">
							<template scope="scope">
								{{scope.row.orderCategory|dictname('xiaoshou_quyu') }}
								{{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
							</template>
						</el-table-column>
						<el-table-column
								prop="soldToCode"
								label="售达方编码"
								width="110">
						</el-table-column>
						<el-table-column
								prop="soldToName"
								label="售达方名称"
								:show-overflow-tooltip="true"
								min-width="180">
								<template scope="scope">
									<div style="text-align: left;">
										{{scope.row.soldToName}}
									</div>
								</template>
						</el-table-column>
						<el-table-column
								prop="soldToAreaName"
								label="售达方地区"
								:show-overflow-tooltip="true"
								width="110">
						</el-table-column>
						<el-table-column
								prop="qyname"
								label="区域"
								:show-overflow-tooltip="true"
								width="110">
						</el-table-column>
						<el-table-column
								prop="currencyCode"
								label="订单币种"
								:show-overflow-tooltip="true"
								width="110">
						</el-table-column>

						<el-table-column
								prop="orderPrice"
								:show-overflow-tooltip="true"
								label="订单总价"
								width="90">
									<template scope="scope">
										<div style="text-align: right;">
											{{scope.row.orderPrice}}
										</div>
									</template>
						</el-table-column>
						<el-table-column
								prop="orderPriceRbm"
								label="RMB总价"
								:show-overflow-tooltip="true"
								width="100">
									<template scope="scope">
										<div style="text-align: right;">
											{{scope.row.orderPriceRbm}}
										</div>
									</template>
						</el-table-column>

						<el-table-column
								prop="add4"
								label="系统发票号"
								:show-overflow-tooltip="true"
								width="130">
						</el-table-column>
						<el-table-column
								prop="add5"
								label="系统发票日期"
								:show-overflow-tooltip="true"
								width="130">
						</el-table-column>
						<el-table-column
								prop="invoicejsCode"
								label="结算发票号"
								:show-overflow-tooltip="true"
								width="160">
						</el-table-column>
						<el-table-column
								prop="fhdate"
								label="发货日期"
								:show-overflow-tooltip="true"
								width="160">
						</el-table-column>
						<el-table-column
								prop="totalGscodePriceEx"
								label="公司间交易金额"
								:show-overflow-tooltip="true"
								width="130">
						</el-table-column>

						<!--
						<el-table-column
								prop="orderNetWorth"
								label="不含税总价"
								:show-overflow-tooltip="true"
								width="110">
									<template scope="scope">
										<div style="text-align: right;">
											{{scope.row.orderNetWorth}}
										</div>
									</template>
						</el-table-column>
						-->

						<el-table-column
								prop="customsCode"
								label="报关单状态"
								:show-overflow-tooltip="true"
								width="110">
							 <template slot-scope="scope">
							  <div v-if="scope.row.customsCode == '' || scope.row.customsCode == null">未录入</div>
							  <div v-else>已录入</div>
							 </template>
						</el-table-column>
						<el-table-column
								prop="billCode"
								label="提单状态"
								:show-overflow-tooltip="true"
								width="90">
							 <template slot-scope="scope">
							  <div v-if="scope.row.billCode == '' || scope.row.billCode == null">未录入</div>
							  <div v-else>已录入</div>
							 </template>
						</el-table-column>

						<el-table-column
								prop="customsCode"
								label="报关单号"
								:show-overflow-tooltip="true"
								width="120">
						</el-table-column>
						<el-table-column
								prop="billCode"
								label="提单号"
								:show-overflow-tooltip="true"
								width="120">
						</el-table-column>
						<el-table-column
								prop="billDate"
								label="提单日期"
								:show-overflow-tooltip="true"
								width="130">
						</el-table-column>

						<el-table-column
								prop="billingStatus"
								label="发票是否创建"
								:show-overflow-tooltip="true"
								width="120">
							 <template slot-scope="scope">
							  <div style="text-align: left;" v-if="scope.row.billingStatus == 'Y' ">是</div>
							  <div style="text-align: left;" v-else>否</div>
							 </template>
						</el-table-column>
						<!--<el-table-column-->
								<!--prop="acceptTime"-->
								<!--label="验收时间"-->
								<!--:show-overflow-tooltip="true"-->
								<!--width="100">-->
						<!--</el-table-column>-->
						<!--<el-table-column-->
								<!--prop="isAccept"-->
								<!--label="验收状态"-->
								<!--:show-overflow-tooltip="true"-->
								<!--width="60">-->
							<!--<template scope="scope">-->
								<!--<span v-if="scope.row.isAccept == 1">已验收</span>-->
								<!--<span v-if="scope.row.isAccept == 0">未验收</span>-->
							<!--</template>-->
						<!--</el-table-column>-->

						<el-table-column
								fixed="right"
								label="操作"
								width="100"
						>
							<template slot-scope="scope">
								<div>
									<el-button
											size="small" class="h-tableLink h-btn"
											@click="seeFile(scope.row)">查看附件
									</el-button>
								</div>
							</template>
						</el-table-column>

					</el-table>
			<div style="margin-left: 20px;display:flex;justify-content: space-between;margin-top:0.4rem">
				<div style="float: left;display:flex;align-items: center;">
					<el-button class="h-btn h-formBtn h-bgblueQ"
							   @click="importAllbaoguan" >批量上传报关单
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ"
							   @click="importAllruhuo" >批量上传入货通知
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ"
							   @click="importAlltidan">批量上传提单
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ"
							   @click="importAlljsfp" >批量上传结算发票
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" v-auth="'kaipiao'"
							   @click="importAllkaipiao">批量开票
					</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
							   @click="exportExcel">批量导出
					</el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"  v-auth="'baoguandan'"
                     @click="downZips('WXFJ_BGD','报关单')">批量下载报关单
          </el-button>
                </div>
            </div>
            <div v-if="adminFlag" style="margin-left: 20px;display:flex;justify-content: space-between;margin-top:0.1rem">
                <div style="float: left;display:flex;align-items: center;">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="downZips('WXFJ_BGD','报关单')">批量下载报关单
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="downZips('WXFJ_RHTZ','入货通知')">批量下载入货通知
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="downZips('WXFJ_TD','提单')">批量下载提单
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="downZips('WXFJ_KHJSFP','结算单发票')">批量下载结算发票
                    </el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="padding: 0.1rem 0.20rem"
							   @click="printAllInvoiceFlagU">批量打印箱单发票
					</el-button>
				</div>
			</div>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:0.4rem">
                <pagination :page="formInline" @query="query"/>
                <!--


                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                           @click="uploaddownexcelflagbtn">批量导入
                </el-button>

                <uploaddownexcel
                        :visible.sync="uploaddownexcelflag"
                        v-if="uploaddownexcelflag"
                        clsname="viewOrderImportWxExcel"
                        :startrow="3" @callback="uploadExcelFilecallback"/>
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="printAllInvoice">批量打印箱单发票
                </el-button>
                -->

            </div>
				</div>
			</div>
			</div>

        <!--附件管理-->
        <el-dialog
                :visible.sync="showFujian"
                v-if="showFujian"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>外销订单凭证总览</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:20px;">
                <h3>报关单</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
                <brupload
        				style="margin-top: 0.1rem;"
                        @filecallback="fjStatus(fjCode)"
                        :refid="refid"
                        reftype="WXFJ_BGD"
                        :uploadflag = "fjFlag"
                        delflag/>
                <el-input v-model="customsCode" placeholder="请输入报关单号"
                          style="width: 100%;margin-top: 0.1rem;"></el-input>
            </div>
            <div class="h-formLine" style="padding:20px;">
                <h3>入货通知</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">发货后开放上传</h6>
                <brupload
        				style="margin-top: 0.1rem;"
                        @filecallback="fjStatus(fjCode)"
                        :refid="refid"
                        reftype="WXFJ_RHTZ"
                        :uploadflag = "fjFlag"
                        delflag/>
            </div>
            <div class="h-formLine" style="padding:20px;">
                <h3>提单</h3><h6 v-if="!fjFlag" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">开具发票后开放上传</h6>
                <brupload
        				style="margin-top: 0.1rem;"
                        :refid="refid"
                        reftype="WXFJ_TD"
                        :uploadflag = "fjFlag"
                        delflag/>
                <el-input v-model="billCode" placeholder="请输入提单号"
                          style="width: 100%;margin-top: 0.1rem;"></el-input>
                <el-date-picker
                        placeholder="请选择提单日期"
                        v-model="billDate"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
        				style="margin-top: 0.1rem;">
                </el-date-picker>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="showFujian = false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitFujian">提 交</el-button>
            </div>
        </el-dialog>

                <!--附件管理-查看/下载全部附件-->
                <el-dialog
                        :visible.sync="showFujianD"
                        v-if="showFujianD"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>外销订单凭证总览</h1>
                            </div>
                        </div>
                    </div>
                	<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                	    <h3 style="display: inline-block;">订单号:</h3>
                		<h4 style="display: inline-block;margin-left: 0.1rem;">{{ddhU}}</h4>
                	</div>
                    <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                        <h3 style="display: inline-block;">报关单</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
                        <brupload
                				style="margin-top: 0.1rem;"
                                @filecallback="fjStatus(fjCode)"
                                :refid="refid"
                                reftype="WXFJ_BGD"
                                :uploadflag = "fjFlag && !(this.bS == 'Y')"
                                :delflag = "!(this.bS == 'Y')"/>
                        <el-input v-model="customsCode" placeholder="请输入报关单号"
                                  style="width: 100%;margin-top: 0.1rem;"></el-input>
                    </div>
                    <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                        <h3 style="display: inline-block;">入货通知</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
                        <brupload
                				style="margin-top: 0.1rem;"
                                @filecallback="fjStatus(fjCode)"
                                :refid="refid"
                                reftype="WXFJ_RHTZ"
                                :uploadflag = "fjFlag && !(this.bS == 'Y')"
                                :delflag = "!(this.bS == 'Y')"/>
                    </div>
                    <div class="h-formLine" style="padding:20px;">
                        <h3 style="display: inline-block;">提单</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(开具发票后开放上传)</h6>
                        <brupload
                				style="margin-top: 0.1rem;"
                                :refid="refid"
                                reftype="WXFJ_TD"
                                :uploadflag = "fjFlag && !(this.bS == 'Y')"
                                :delflag = "!(this.bS == 'Y')"/>
                        <div style="display: flex;justify-content: space-between;">
                			<el-input v-model="billCode" placeholder="请输入提单号"
                			          style="width: 45%;margin-top: 0.1rem;"></el-input>
                			<el-date-picker
                			        placeholder="请选择提单日期"
                			        v-model="billDate"
                			        clearable
                			        type="date"
                			        value-format="yyyy-MM-dd"
                			        style="margin-top: 0.1rem;width: 45%">
                			</el-date-picker>
                		</div>
                    </div>
					<div class="h-formLine" style="padding:20px;">
						<h3 style="display: inline-block;">客户结算发票</h3>
						<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(开具发票后开放上传)</h6>
						<brupload
								style="margin-top: 0.1rem;"
								:refid="refid"
								reftype="WXFJ_KHJSFP"
								uploadflag = "ture"
								delflag = "ture"/>

						<div style="display: flex;justify-content: space-between;">
							<el-input v-model="invoicejsCode" placeholder="请输入结算发票号"
									  style="width: 45%;margin-top: 0.1rem;"></el-input>
							<el-date-picker
									placeholder="请选择结算发票日期"
									v-model="invoicejsDate"
									clearable
									type="date"
									value-format="yyyy-MM-dd"
									style="margin-top: 0.1rem;width: 45%">
							</el-date-picker>
						</div>
					</div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitFujian">提 交</el-button>
                    </div>
                </el-dialog>

                <!--附件管理-批量上传报关单号-->
                <el-dialog
                        :visible.sync="showFujianA"
                        v-if="showFujianA"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>外销订单凭证总览</h1>
                            </div>
                        </div>
                    </div>
                	<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                	    <h3 style="display: inline-block;">订单号:</h3>
                		<h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
						<h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">请填写准确的报关单号信息并上传对应的报关单+入货通知（入货通知可用提单/运输单据代替），两项必须完整，单据以“订单号+单据名称”命名，以上信息完整方可开票</h6>
                	</div>
                    <div class="h-formLine" style="padding:20px;">
                        <h3 style="display: inline-block;">报关单</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
                        <brupload
                				 style="margin-top: 0.1rem;"
                                @filecallback="fjStatusA"
                                :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
                                reftype="WXFJ_BGD"
                                :uploadflag = "fjFlag && !(this.bS == 'Y')"
                                :delflag = "!(this.bS == 'Y')"/>
                        <el-input v-model="customsCode" placeholder="请输入报关单号"
                                  style="width: 100%;margin-top: 0.1rem;"></el-input>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitFujianA">提 交</el-button>
                    </div>
                </el-dialog>

                <!--附件管理-批量上传入货通知-->
                <el-dialog
                        :visible.sync="showFujianC"
                        v-if="showFujianC"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>外销订单凭证总览</h1>
                            </div>
                        </div>
                    </div>
                	<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                	    <h3 style="display: inline-block;">订单号:</h3>
                		<h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                	</div>
                    <div class="h-formLine" style="padding:20px;">
                        <h3 style="display: inline-block;">入货通知</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发货后开放上传)</h6>
                        <brupload
                				style="margin-top: 0.1rem;"
                                @filecallback="fjStatusA"
                                :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
                                reftype="WXFJ_RHTZ"
                                :uploadflag = "fjFlag && !(this.bS == 'Y')"
                                :delflag = "!(this.bS == 'Y')"/>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitFujianC">提 交</el-button>
                    </div>
                </el-dialog>

                <!--附件管理-批量上传提单号-->
                <el-dialog
                        :visible.sync="showFujianB"
                        v-if="showFujianB"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>外销订单凭证总览</h1>
                            </div>
                        </div>
                    </div>
                	<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                	    <h3 style="display: inline-block;">订单号:</h3>
                		<h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                	</div>
                    <div class="h-formLine" style="padding:20px;">
                        <h3 style="display: inline-block;">提单</h3>
                		<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(开具发票后开放上传)</h6>
                        <brupload
                				style="margin-top: 0.1rem;"
                                :refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
                                reftype="WXFJ_TD"
                                :uploadflag = "fjFlag"
                                :delflag = "true"/>
                        <div style="display: flex;justify-content: space-between;">
                			<el-input v-model="billCode" placeholder="请输入提单号"
                			          style="width: 45%;margin-top: 0.1rem;"></el-input>
                			<el-date-picker
                			        placeholder="请选择提单日期"
                			        v-model="billDate"
                			        clearable
                			        type="date"
                			        value-format="yyyy-MM-dd"
                			        style="margin-top: 0.1rem;width: 45%">
                			</el-date-picker>
                		</div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitFujianB">提 交</el-button>
                    </div>
                </el-dialog>

		<el-dialog
				:visible.sync="showFujianE"
				v-if="showFujianE"
				class="h-dialog2"
		>
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>外销订单凭证总览</h1>
					</div>
				</div>
			</div>
			<div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
				<h3 style="display: inline-block;">订单号:</h3>
				<h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
			</div>
			<div class="h-formLine" style="padding:20px;">
				<h3 style="display: inline-block;">客户结算发票</h3>
				<h6 v-if="!fjFlag" style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(开具发票后开放上传)</h6>
				<brupload
						style="margin-top: 0.1rem;"
						:refid="_.join(_.map(this.tableSelectedList,'sapCode'),',')"
						reftype="WXFJ_KHJSFP"
						uploadflag = "ture"
						delflag = "ture"/>
				<div style="display: flex;justify-content: space-between;">
					<el-input v-model="invoicejsCode" placeholder="请输入结算发票号"
							  style="width: 45%;margin-top: 0.1rem;"></el-input>
					<el-date-picker
							placeholder="请选择结算发票日期"
							v-model="invoicejsDate"
							clearable
							type="date"
							value-format="yyyy-MM-dd"
							style="margin-top: 0.1rem;width: 45%">
					</el-date-picker>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
				<el-button class="h-btn h-bBtn" @click="submitFujianE">提 交</el-button>
			</div>
		</el-dialog>

                <!--批量开票-->
                <el-dialog
                        :visible.sync="showKaipiao"
                        v-if="showKaipiao"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>外销订单开票确认</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                        <h3 style="display: inline-block;">订单号:</h3>
                        <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitKaipiao">确 认</el-button>
                    </div>
                </el-dialog>


        <!--创建订单弹出框-->
        <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false"/>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


        <el-dialog :close-on-click-modal="false" title="作废订单" :visible.sync="zfyydialogFormVisible">
            <el-form :model="zuofeiyy">
                <el-form-item label="作废原因" :label-width="100">
                    <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                              v-model="zuofeiyy.yy" ></brselect>
                </el-form-item>
                <el-form-item label="备注" :label-width="100">
                    <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="zfyydialogFormVisible = false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="撤回订单" :visible.sync="chehuidialogFormVisible">
            <el-form :model="zuofeiyy">
                <el-form-item label="撤回原因" :label-width="100">
                    <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                              v-model="zuofeiyy.yy" ></brselect>
                </el-form-item>
                <el-form-item label="备注" :label-width="100">
                    <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="chehuidialogFormVisible = false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="chehui">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    import engTable from '../../api/dingd/ProductEngTable'
    export default {
        props: ["firstPageFlag"],
        components: {
            uploaddownexcel,
        },
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				// 查看附件的订单号
				ddhU:'',
				// 上传报关单号的订单号
				ddhB:'',
                //撤回
                chehuidialogFormVisible: false,
                //导入Excel
                uploaddownexcelflag: false,

                fjFlag: null,
                fjCode: null,
                id: null,
                fhStatus: null,
                refid: null,
                reftype: null,
                showFujian: null,
                showFujianA: null,
                showFujianB: null,
                showFujianC: null,
                showFujianD: null,
                showFujianE:null,
                showKaipiao: null,
                bS: null,

                instid: null,
                showhistory: null,

                imgflag3: false,
                orderTypeList: [],
                orderCategory1AllList:[],
                orderCategory1List:[],

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
				isDateFlag: false,
                //表单
                formInline: {
                    qyname:null,
                    blstatus:null,
                    csstatus:null,
                    pageSize: 20,
                    pageNo: 1,
                    total: 0,
                    rhstatus:null,
                    ownShenpiFlag: false,
                    ownShenpi: '',
                    cuserCodeNameLike: "",
                    sdfCodeNameLike: "",
                    orderCategory: "",
                    saleGroupCode: "",
                    status: "",
                    cdatebegin:null,
                    cdateend:null,
                    orderTypebz: 2,
                    shouhuoflag:null,
                    flagU: '1',
                    fhdateend:null,
                    fhdatebegin:null,
                    invoicejsDatebegin:null,
                    invoicejsDateend:null,
                    customsCode: null,
                    billCode: null,
                    billDate: null,
                    billingStatus: null,
                    add4: null,
                    bdatebegin: null,
                    bdateend: null,
                    statusName:null
                },

                customsCode: null,
                billCode: null,
                billDate: null,
                invoicejsCode:null,
                invoicejsDate:null,
                billingStatus: null,
                add4: null,

                spanArr: [],
                //作废原因
                zfyydialogFormVisible:false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                },
                areaData:[],
                adminFlag:false,
                tableSelectedList:[],
				isFile:null
            }
        },

        created() {
            var data = this.$store.getters.dictlist("neibu_haiwai_area");
            for (var i = 0; i < data.length; i++) {
                if (data[i].code != '000' && data[i].code != '200' && data[i].code != '270' && data[i].code != '280' && data[i].code != '300'
                    && data[i].code != '310' && data[i].code != '330' && data[i].code != '340' && data[i].code != '8002' && data[i].code != '8003' && data[i].code != '8001') {
                    this.areaData.push(data[i]);
                }
            }
            this.query();
            this.adminFlag = this.$store.getters.hasRole('fapiaogly');
            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
			this.isDate();
            //    项目
            //     this.listPro();
        },
        methods: {
            dateFormatter(str){//默认返回yyyy-MM-dd HH-mm-ss
                var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
                var d = new Date(str);
                var year = d.getFullYear();
                var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
                var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
                var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
                var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
                var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
                console.log("日期",hour)
                return [year, month, day].join('-');
            },
            tableRowClassName({row, rowIndex}) {
				if (!row.typeFlage) {
					return 'warning-row';
				}
                return '';
            },
            // isFiles(sapCode){
             //    var reftype = 'WXFJ_BGD,WXFJ_RHTZ,WXFJ_TD,WXFJ_KHJSFP'
             //    ss.OrderMainService.isList(reftype,sapCode,2).then(rd => {
             //        this.isFile = rd;
             //    });
			// },
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},

            //撤回订单
            sapCHOrder(row) {
                this.$msg.confirm("确认从SAP作废并撤回订单?", () => {
                    this.zuofeiyy.id = row.bid
                    this.chehuidialogFormVisible = true;
                });
            },
            chehui(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择撤回原因");
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认撤回?", () => {
                    ss.OrderMainService.sapCHOrder(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.chehuidialogFormVisible = false
                    });
                });
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            changeOrderCate(cate){
                if(cate){
                    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
                }else{
                    this.orderCategory1List =  [];
                }

            },
            //批量导出
            exportExcel() {
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                var form = _.clone(this.formInline);
                form.strids=strids;
                updownfile.down("/api/swyl/v1/demo/viewOrder/downloadFileExcel", form, "post");
            },
            //批量下载
            downZips(data,name) {
                var d = new Date();
                var year = d.getFullYear();
                var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
                var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
                var strids = _.join(_.map(this.tableSelectedList,"id"),",");
                this.formInline.statusName = data;
                var form = _.clone(this.formInline);
                form.strids=strids;
                ss.OrderMainService.downloadZip(form).then(res => {
                    if(res.size == 0){
                        this.$msg.msge("选择的订单中没有相关附件");
                        return false;
					}
                    // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'multipart/form-data'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    var fileName = name+'批量下载'+year+month+day+'.zip'
                    link.setAttribute('download', fileName)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },


			//批量上传报关单号
			importAllbaoguan() {
				if(this.ddhB == ''){
					this.$msg.msge("请勾选以上订单!!!");
					return false;
				}
				var flag1 = false
				this.tableSelectedList.forEach((item, index) => {
					if(!(item.status != 70 && item.orderCategory == 2)){
						flag1 = true;
						return;
					}
				})
				if(flag1){
					this.$msg.msge("审核通过后的正常订单才能上传报关单号,请重新选择!");
					return;
				}

				this.fjFlag = true;
				this.bS = 'N';
				this.tableSelectedList.forEach((item, index) => {
					if(item.status < 50){
						this.fjFlag = false;
					}
					if(item.billingStatus == 'Y'){
						this.bS = 'Y';
					}
				})
				this.showFujianA = true;
			},

			//批量上传入货单
			importAllruhuo() {
				if(this.ddhB == ''){
					this.$msg.msge("请勾选以上订单!!!");
					return false;
				}
				var flag1 = false
				this.tableSelectedList.forEach((item, index) => {
					if(!(item.status != 70 && item.orderCategory == 2)){
						flag1 = true;
						return;
					}
				})
				if(flag1){
					this.$msg.msge("审核通过后的正常订单才能上传入货单,请重新选择!");
					return;
				}

				this.fjFlag = true;
				this.bS = 'N';
				this.tableSelectedList.forEach((item, index) => {
					if(item.status < 50){
						this.fjFlag = false;
					}
					if(item.billingStatus == 'Y'){
						this.bS = 'Y';
					}
				})
				this.showFujianC = true;
			},

			//批量上传提单号
			importAlltidan() {
				if(this.ddhB == ''){
					this.$msg.msge("请勾选以上订单!!!");
					return false;
				}
				var flag1 = false
				this.tableSelectedList.forEach((item, index) => {
					if(!(item.status != 70 && item.orderCategory == 2)){
						flag1 = true;
						return;
					}
				})
				if(flag1){
					this.$msg.msge("审核通过后的正常订单才能上传提单号,请重新选择!");
					return;
				}

				this.fjFlag = true;
				this.bS = 'N';
				this.tableSelectedList.forEach((item, index) => {
					if(item.status < 50){
						this.fjFlag = false;
					}
					if(item.billingStatus == 'Y'){
						this.bS = 'Y';
					}
				})
				this.showFujianB = true;
			},

            //批量上传结算单号
            importAlljsfp() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选以上订单!!!");
                    return false;
                }
                var flag1 = false
				var flag2 = false
                this.tableSelectedList.forEach((item, index) => {
                    if(!(item.status != 70 && item.orderCategory == 2)){
                        flag1 = true;
                        return;
                    }
                    if(item.status < 50){
						flag2 = true;
						return;
					}
                })
                if(flag1){
                    this.$msg.msge("审核通过后的正常订单才能上传提单号,请重新选择!");
                    return;
                }
				if(flag2){
					this.$msg.msge("已安排发货的订单才能上传结算发票，请重新选择!");
					return;
				}
                this.fjFlag = true;
                this.bS = 'N';
                this.tableSelectedList.forEach((item, index) => {
                    if(item.status < 50){
                        this.fjFlag = false;
                    }
                    if(item.billingStatus == 'Y'){
                        this.bS = 'Y';
                    }
                })
                this.invoicejsDate = this.dateFormatter(new Date(),false);
                this.showFujianE = true;
            },

                        //批量开票
                        importAllkaipiao() {
							if(this.ddhB == ''){
								this.$msg.msge("请勾选要开票的订单!!!");
								return false;
							}
                            var flag1 = false
                            this.tableSelectedList.forEach((item, index) => {
                                if(item.customsCode == null || item.customsCode == ''){
                                    flag1 = true;
                                    return;
                                }
                            })
                            if(flag1){
                                this.$msg.msge("已维护报关单号的订单才可以开票,请重新选择!");
                                return;
                            }
                            this.showKaipiao = true;
                        },

            //导出箱单发票Excel
            printInvoice(x) {
                this.$msg.confirm("确认打印?", () => {
                    updownfile.down('/api/swyl/v1/dingdmain/printInvoice',{sapId:x},"post");
                    // ss.OrderMainService.printInvoice(x).then(rd => {
                    //     this.$msg.msgs(rd.msg);
                    // });
                });
            },

            //导出箱单发票Excel
            printPI(x) {
                this.$msg.confirm("确认打印?", () => {
                    updownfile.down('/api/swyl/v1/dingdmain/printPI',{sapId:x},"post");
                });
            },
            ownShenpiFlag(){
                if(this.formInline.ownShenpiFlag){
                    this.formInline.ownShenpi = '1';
                }else {
                    this.formInline.ownShenpi = '';
                }
                console.log('我在这儿呀', this.formInline.ownShenpi);
            },

            //财务收货
            caiwushouhuo(){
                console.log(this.tableSelectedList)
                if(this.tableSelectedList.length == 0){
                    this.$msg.msge("至少选中一条操作！");
                    return false;
                }
                var shlist = [];
                for(var i=0;i<this.tableSelectedList.length;i++){
                    var obj = this.tableSelectedList[i];

                    if( obj.status!='50'){
                        this.$msg.msge("选中的订单状态不对，只有已发货的才能执行收货操作！");
                        return false;
                    }else{
                        shlist.push(obj);
                    }
                }
                ss.OrderMainService.updateShouhuoflag(_.join(_.map(shlist,"bid"),",")).then(rd=>{
                    this.$refs['ddtable'].clearSelection();
                    this.$msg.msgs("更新收货状态成功！");
                    this.query();
                })
            },
            //批量导出箱单发票Excel
			printAllInvoiceFlagU() {
                var flag1 = false
                var flag2 = false
                this.tableSelectedList.forEach((item, index) => {
                    if(!(item.status > 30 && item.status != 70 && item.orderCategory == 2)){
                        flag1 = true;
                        return;
                    }
                })

                if(flag1){
                    this.$msg.msge("审核通过后的正常订单才能打印箱单发票,请重新选择!");
                    return;
                }
                var strids = _.join(_.map(this.tableSelectedList,"sapCode"),",");
                this.$msg.confirm("确认打印?", () => {

                    engTable.checkByMaterialCode({sapIds:strids}).then(rd => {
                        if (rd.msg !="") {
                            this.$alert(rd.msg, '提示', {
                                confirmButtonText: '确定',
                                type:'warning',
                                callback: action => {
                                    updownfile.down('/api/swyl/v1/dingdmain/printAllInvoiceFlagU',{sapIds:strids},"post");
                                }
                            });
                        } else {
                            updownfile.down('/api/swyl/v1/dingdmain/printAllInvoiceFlagU',{sapIds:strids},"post");
                        }
                    })

                });
            },
            handleSelectionChange(lists){
                this.tableSelectedList = lists;
				var str = '';
				for(var i=0;i<lists.length;i++){
					str += lists[i].sapCode + ',';
				}
				str = str.substring(0,str.length-1);
				this.ddhB = str;
            },
            //附件管理
            opendia(o) {
                this.fjFlag = o.status < 50 ? false : true;
                this.fjCode = o.sapCode;
                this.id = o.id;
                this.fhStatus = o.status;
                console.log('我在这儿呀', o.status);
                this.refid = o.sapCode;
                this.showFujian = true;
            },
            //查看附件
            seeFile(o) {
                this.fjFlag = o.status < 50 ? false : true;
                this.fjCode = o.sapCode;
                this.id = o.id;
                this.fhStatus = o.status;
                console.log('我在这儿呀', o.status);
                console.log('wtf???', o.billingStatus);
                this.bS = o.billingStatus;
                this.refid = this.ddhU = o.sapCode;
                this.customsCode = o.customsCode;
                this.billCode = o.billCode;
                this.billDate = o.billDate;
                this.invoicejsCode = o.invoicejsCode;
                if(o.invoicejsDate == null || o.invoicejsDate == ""){
                    this.invoicejsDate = this.dateFormatter(new Date(),false);
				}else {
                    this.invoicejsDate = o.invoicejsDate;
                }
                this.showFujianD = true;
            },

            fjStatus(x) {
                ss.OrderMainService.updateFjStatus(x).then(rd => {
                });
            },
            fjStatusA() {
                var saps = _.join(_.map(this.tableSelectedList,"sapCode"),",");
                //console.log('saps', saps);
                ss.OrderMainService.updateFjStatusA(saps).then(rd => {
                });
            },

            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].id === this.tableData[index - 1].id) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (
                    (
                        columnIndex == 0 && row.orderCategory == '2'
                    )
                    ||
                    (
                        columnIndex >= 6 && columnIndex <= 19 && column.label != '订单状态'
                        && column.label != '销售组织' && column.label != '公司间交易金额'
                    )
                    ||
                    (
                        column.label == '订单号' && row.orderCategory == '2' && row.orderCategory1 != '26'
                    )
                    ||
                    (
                        (column.label == '订单状态' || column.label == '操作') &&
                        (row.status == '10' || row.orderCategory == '2')
                    )
                ) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            genzongLiuch(r) {
                console.log(r);
                if (r.orderCategory == '1' || r.orderCategory == '3' || r.orderCategory1 == '26') {
                    this.instid = r.binstid;
                } else {
                    this.instid = r.instid;
                }
                this.showhistory = true;
            },
            imgfalse3() {
                this.imgflag3 = true;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectDingdanPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    console.log('tableData', this.tableData);
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            shenpiopt(row, flag){
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                this.$router.push({
                    path: row.dburl,
                    query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
                })
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },

            // 重置按钮
            resetData() {
                this.formInline.qyname = null;
                this.formInline.sapCode = null;
                this.formInline.blstatus = null;
                this.formInline.csstatus = null;
                this.formInline.rhstatus = null;
                this.formInline.ownShenpiFlag = false;
                this.formInline.ownShenpi = "";
                this.formInline.cuserCodeNameLike = "";
                this.formInline.sdfCodeNameLike = "";
                this.formInline.orderCategory = "";
                this.formInline.saleGroupCode = "";
                this.formInline.status = "";
                this.formInline.cdatebegin = null;
                this.formInline.cdateend = null;
                this.formInline.orderTypebz = 2;
                this.formInline.shouhuoflag = null;
                this.formInline.flagU = '1';

                this.formInline.customsCode = null;
                this.formInline.billCode = null;
                this.formInline.billDate = null;
                this.formInline.billingStatus = null;
                this.formInline.add4 = null;
                this.formInline.bdatebegin = null;
                this.formInline.bdateend = null;
                this.formInline.fhdateend=null;
				this.formInline.fhdatebegin=null;
                this.formInline.invoicejsDatebegin=null;
                this.formInline.invoicejsDateend=null;
            },


            handleEdit(row) {
                console.log(row)
                this.toEdit(row.orderCategory, row.orderCategory1, row.id);
                // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
            },
            handelDetail(row) {
                var instid = null;
                if (row.orderCategory == '1' || row.orderCategory1 == '26') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                // if (row.orderCategory == '1' || row.orderCategory == '3') {
                //     this.$router.push({
                //         path: "/dingdmain/orderNxshenpi",
                //         query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                //     })
                // } else {
                //     this.$router.push({
                //         path: "/dingdmain/orderWxshenpi",
                //         query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                //     })
                // }
                let pathsp = row.orderCategory1 == '26' ? "/dingdmain/orderNxshenpi" : "/dingdmain/orderWxshenpi";
                let routeData = this.$router.resolve({
                    path: pathsp,
                    query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                });
                window.open(routeData.href, '_blank');
            },


            //开票
            makeInvoice(x) {
                this.$msg.confirm("确认开票?", () => {
                    ss.OrderMainService.makeInvoice(x).then(rd => {
                        this.$msg.msgs(rd.msg);
                    });
                });
            },

            //作废订单
            sapDeleteOrder(row) {
                if (row.status == '10') {
                    this.$msg.confirm("确认作废?", () => {
                        ss.OrderMainService.sapDeleteOrder(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },

            //删除订单
            sapDeleteOrder2(row) {
                if (row.status == '10' || row.status == '30' || row.status == '70') {
                    this.$msg.confirm("确认删除?", () => {
                        ss.OrderMainService.sapDeleteOrder2(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },

            submitzuofei(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择作废原因");
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认作废?", () => {
                    ss.OrderMainService.sapDeleteOrder(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.zfyydialogFormVisible = false
                    });
                });
            },

            submitFujian(){
				if(this.customsCode != null){
                    var a = this.customsCode.toString();
                    if(a.length != 18){
                        return this.$msg.msge("报关单号不是18位，无法提交！");
                    }
				}
                var orderM = {
                    id : this.id,
                    customsCode : this.customsCode,
                    billCode : this.billCode,
                    billDate : this.billDate,
                    invoicejsCode : this.invoicejsCode,
                    invoicejsDate : this.invoicejsDate
                };
                //console.log('orderM', orderM);
                ss.OrderMainService.updateByModel(orderM).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                    this.showFujianD = false
                });
                this.customsCode = null;
                this.billCode = null;
                this.billDate = null;
                this.invoicejsCode = null;
                this.invoicejsDate = null;
            },

            cancel(){
                this.showFujianA = false;
                this.showFujianB = false;
                this.showFujianC = false;
                this.showFujianD = false;
                this.showFujianE = false;
                this.showKaipiao = false;
                this.customsCode = null;
                this.billCode = null;
                this.billDate = null;
                this.invoicejsCode =null;
                this.invoicejsDate = null;
            },

                        submitFujianA(){
                            if(this.customsCode != null){
                                var a = this.customsCode.toString();
                                if(a.length != 18){
                                    return this.$msg.msge("报关单号不是18位，无法提交！");
                                }
                            }
                            var ids = _.join(_.map(this.tableSelectedList,"id"),",");
                            var orderM = {
                                id : ids,
                                customsCode : this.customsCode
                            };
                            console.log('orderM', orderM);
                            ss.OrderMainService.updateByModelA(orderM).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.query();
                                this.showFujianA = false
                            });
                            this.customsCode = null;
                        },

                        submitFujianC(){
                            this.$msg.msgs("上传成功");
                            this.query();
                            this.showFujianC = false
                        },

                        submitFujianB(){
                            var ids = _.join(_.map(this.tableSelectedList,"id"),",");
                            var orderM = {
                                id : ids,
                                billCode : this.billCode,
                                billDate : this.billDate
                            };
                            console.log('orderM', orderM);
                            ss.OrderMainService.updateByModelB(orderM).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.query();
                                this.showFujianB = false
                            });
                            this.billCode = null;
                            this.billDate = null;
                        },

            submitFujianE(){
                var ids = _.join(_.map(this.tableSelectedList,"id"),",");
                var orderM = {
                    id : ids,
                    invoicejsCode : this.invoicejsCode,
                    invoicejsDate : this.invoicejsDate
                };
                ss.OrderMainService.updateByModelE(orderM).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                    this.showFujianE = false
                });
                this.invoicejsCode = null;
                this.invoicejsDate = null;
            },

                        submitKaipiao(){
                            var ids = _.join(_.map(this.tableSelectedList,"sapCode"),",");
                            console.log('ids', ids);
                            ss.OrderMainService.makeInvoiceAll(ids).then(rd => {
                                this.$msg.msgs(rd.msg);
                                this.query();
                                this.showKaipiao = false
                            });
                        },

            toEdit(ddlx, ddzlx, id) {
                if (ddlx == '1') {
                    if (ddzlx == '9') {
                        //服务订单
                        this.$router.push({path: "/dingd/createFuwuOrder", query: {id: id}})
                        return;
                    }
                    this.$router.push({path: "/dingd/createNxOrder", query: {id: id}})
                } else if (ddlx == '2') {
                    //外销
                    if (ddzlx == '25') {
                        //服务订单
                        this.$router.push({path: "/dingd/createWxFuwuOrder", query: {id: id}})
                        return;
                    }
                    if (ddzlx == '26') {
                        //外贸订单
                        this.$router.push({path: "/dingd/createWMOrder", query: {id: id}})
                        return;
                    }
                    this.$router.push({path: "/dingd/createWxOrder", query: {id: id}})
                    return;
                } else {
                    //上海直销
                    this.$router.push({path: "/dingd/createNxOrder", query: {id: id}})
                }
            },
			//判断当前日期是否在允许签收的时间范围之内
			isDate(){
				ss.OrderMainService.isDate().then(rd =>{
					this.isDateFlag = rd.msg;
				})
			},
            handleDelete(row) {

            },
            //导出Excel
            /*downloadExcel() {

                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.pid);
                });

                this.q.ids = idlist;
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.orderType = this.formInline.orderType;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;
                this.q.saleGroupCode = this.formInline.saleGroupCode;
                this.q.orderStatus = this.formInline.orderStatus;

                updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

            },*/

        },

        mounted() {

        },

    }
</script>
<style>
	.el-table .warning-row {
		background: #ffd200;
		color:red;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

</style>
